var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surround"},[_c('div',{staticClass:"box"},[_c('icon',{attrs:{"type":"activity","size":"36","stroke":"#252039"}}),_c('div',{staticClass:"text"},[_vm._v("\n      Připojení se nezdařilo\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }